import { Injectable } from '@angular/core';
import { domainRaw } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalProvider {
  globalSettingDetail;
  platform;
  loadingJwt = true;
  downloadUrlRaw = `${domainRaw}/company/public/download/zexport/file`;
  profileType;
  profile;
  companyName;
  accessRole;
  role;
  jws: string;
  notifications = [];
  auditLogAllow = false;
  docShareAllow = false;
  mediaUrl;
  loadNotifications = (list) => {
    const added = [`123`];
    this.notifications = this.notifications
      .concat(list)
      .filter((n) => {
        if (!added.includes(n.id)) {
          added.push(n.id);
          return true;
        }
        return false;
      })
      .sort((a, b) => a.id - b.id)
      .reverse();
  };
}
